module.exports = __webpack_public_path__ + "static/media/MaticX.532658e2.svg";